import React from 'react'
import classNames from 'classnames'
import Popup from './Popup'
import './index.less'

export type TPosition = 'topLeft' | 'top' | 'topRight' | 'rightTop' | 'right' | 'rightBottom' | 'bottomRight' | 'bottom' | 'bottomLeft' | 'leftBottom' | 'left' | 'leftTop';

export interface DropdownProps{
    overlay:React.ReactNode,
    children?: React.ReactNode,
    style?:React.CSSProperties,
    overlayStyle?:React.CSSProperties,
    className?:string,
    overlayWrapClassName?:string,
    overlayClassName?:string,
    onVisibleChange?:(val: boolean)=>void,
    disabled?:boolean,
    position?: TPosition,
    root?(): Element;
    visible?: boolean;
    trigger?: 'hover' | 'click';
    closeOnClickTrigger?: boolean;
    animation?: 'Opacity' | 'Scale' | 'Fade' | string;
    prefixClass?: string;
}

interface IOverlay{
  overlay: React.ReactNode,
  overlayClassName?:string,
  overlayStyle?:React.CSSProperties,
}

export const Overlay = ({ overlay, overlayClassName, overlayStyle }:IOverlay) => {
  return <div className={classNames('zy-dropdown-overlay', overlayClassName)} style={overlayStyle}>
    {overlay}
  </div>
}

export default function Dropdown({
  overlay,
  overlayStyle,
  children,
  overlayClassName,
  overlayWrapClassName,
  className,
  position = 'bottomLeft',
  onVisibleChange,
  disabled = false,
  ...otherProps
}: DropdownProps) {
  return <div className={classNames('zy-dropdown-wrap', className)}>
    {
    !disabled && <Popup
      prefixClass="zy"
      position={position}
      onVisibleChange={(vis: any) => onVisibleChange?.(vis.value)}
      className={overlayWrapClassName}
      {...otherProps}
    >
      <Overlay overlay={overlay} overlayClassName={overlayClassName} overlayStyle={overlayStyle} />
    </Popup>
    }
    {children}
  </div>
}
